import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import ValidateContinueButton from 'app-ui-componentlibrary/dist/go/components/common/ValidateContinueButton';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {shouldDisplay} from 'componentLibrary/layout/ShowHide';
import {stringToNum, scrollIt} from 'common/utils';

class DynamicValidateContinueButton extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      fullValidationRun: false,
      isHiddenSection: true,
    };
  }

  validateContinueClick = () => {
    if (this.state.fullValidationRun) {
      this.continue();
      this.setState({
        fullValidationRun: false,
      });
    }

    if (!this.state.fullValidationRun) {
      const validationIds = this.getValidationIds(this.props.section, 'validationId');
      let errorsExist = false;
      _.forEach(validationIds, (id) => {
        let errorsList = _.get(this.props.validationErrors.errors, id);
        // Trigger an error message if any validation fails.
        if (errorsList !== undefined) {
          _.forEach(errorsList, (error) => {
            if (error.isValid === false) {
              errorsExist = true;
            }
          });
        }
      });

      if (errorsExist === true) {
        this.setState({
          fullValidationRun: true,
        });
        _.forEach(validationIds, (id) => {
          this.props.triggerDirtyMap(id);
        });
      } else {
        this.continue();
      }
    }
  };

  continue = () => {
    //check if the next section is a hidden section, if so skip
    //get current location
    const locationTop = this.props.currentLocation.match(/^contents\[(\d+)\]/);
    let count = 0;

    if (stringToNum(locationTop[1]) < this.props.sections.length) count = count + 1;
    for (let x = stringToNum(locationTop[1]) + 1; x < this.props.sections.length; x++) {
      let section = this.props.sections[x];
      if (section.type === 'ShowHide') {
        let propsWithDependencies = {...this.props};
        const dependencies = _.get(section.dependencies, '0');
        const keys = Object.keys(_.get(section.dependencies, '0'));
        _.each(
          keys,
          (key) =>
            (propsWithDependencies[key] = _.get(
              this.props.dynamicComponent,
              dependencies[key]
            ))
        );

        propsWithDependencies['shouldDisplayIfAnyRules'] = _.get(
          section,
          'shouldDisplayIfAnyRules'
        );

        let isHidden = !shouldDisplay(
          undefined,
          undefined,
          section.shouldDisplayRules,
          propsWithDependencies
        );
        if (isHidden) count = count + 1;
        else {
          x = this.props.sections.length;
        }
      } else {
        x = this.props.sections.length;
      }
    }

    this.props.navToSpecificLocation(this.props.currentLocation);

    //create new location
    let newLocationNum = stringToNum(locationTop[1]) + count;
    let newLocation = `contents[` + newLocationNum + `]`;
    this.props.navToSpecificLocation(newLocation);
    scrollIt(document.getElementById('root'), 0, 0);
  };

  getValidationIds = (o, prop) =>
    ((validationIdList) => (
      JSON.stringify(
        o,
        (key, value) => (key === prop && validationIdList.push(value), value)
      ),
      validationIdList
    ))([]);

  render() {
    return (
      <React.Fragment>
        <ValidateContinueButton
          fullValidationRun={this.state.fullValidationRun}
          validateContinueClick={this.validateContinueClick}
          message={this.props.validateContinueErrorMsg}
        />
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const {dynamicComponent} = state;
  const {validationErrors} = state.dynamicComponent;
  return {
    validationErrors,
    dynamicComponent,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  navParent: () => dispatch(DynamicComponentActions.navParent()),
  navSiblingNext: () => dispatch(DynamicComponentActions.navSiblingNext()),
  navToSpecificLocation: (specificLocation) =>
    dispatch(DynamicComponentActions.navToSpecificLocation(specificLocation)),
  triggerDirtyMap: (fieldPath) =>
    dispatch(DynamicComponentActions.triggerDirtyMap(fieldPath)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicValidateContinueButton);
